import { useAuth } from "@clerk/clerk-react";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import api, { checkIsAdmin } from "@/services/api";

export function SyncUsers() {
  const { getToken } = useAuth();
  const [status, setStatus] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      const adminStatus = await checkIsAdmin();
      setIsAdmin(adminStatus);
      setLoading(false);
    };
    checkAdmin();
  }, []);

  const handleSync = async () => {
    try {
      setStatus("Syncing...");
      setError("");
      
      const token = await getToken();
      if (!token) {
        throw new Error("No authentication token available");
      }

      const response = await api.post('/api/v1/users/admin/sync-all');
      
      setStatus(`Success: ${response.data.message}`);
    } catch (err) {
      console.error('Sync error:', err);
      setError(err instanceof Error ? err.message : 'Failed to sync users');
      setStatus("");
    }
  };

  if (loading) return null;
  if (!isAdmin) return null;

  return (
    <div className="p-4">
      <Button onClick={handleSync}>Sync All Users</Button>
      {status && <p className="mt-2 text-green-500">{status}</p>}
      {error && <p className="mt-2 text-red-500">{error}</p>}
    </div>
  );
}
